import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { DatePickerWrapperProps } from 'src/components/DatePickerInput/datePickerWrapperProps';
import { DateRangeInput } from 'src/components/enterprise/components/DateRangeInput/DateRangeInput';

export type BaseDateRangeInputProps = Omit<
  DatePickerWrapperProps,
  'control' | 'error'
>;

export const BaseDateRangeInput: React.FC<BaseDateRangeInputProps> = ({
  name,
  ...rest
}) => {
  const { errors, control } = useFormContext();

  return (
    <DateRangeInput
      name={name}
      {...rest}
      control={control}
      error={errors[name]}
    />
  );
};
